var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationExternal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55 2.497a8.708 8.708 0 0112.314 12.314l-1.188 1.174c-.874.859-2.01 1.963-3.406 3.313a2.25 2.25 0 01-3.128 0L3.652 15.9c-.44-.43-.807-.794-1.103-1.09a8.71 8.71 0 010-12.314zM13.801 3.56A7.208 7.208 0 103.61 13.751l1.487 1.467a742.873 742.873 0 003.088 3 .75.75 0 001.043 0l3.394-3.3c.47-.46.864-.849 1.18-1.167a7.207 7.207 0 000-10.192zM8.707 5.43a3.5 3.5 0 11-.002 7 3.5 3.5 0 01.002-7zm0 1.5a2 2 0 100 4 2 2 0 000-4z",
    fill: "#4E8209"
  })));
}
export default SvgLocationExternal;